// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;
export const DispatchOpenMinicartDrawer: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/MinicartDrawer/openMinicartDrawer",
    });
};
export const chain = [DispatchOpenMinicartDrawer];

const openMinicartDrawer = createHandlerChainRunnerOptionalParameter(chain, {}, "OpenMinicartDrawer");
export default openMinicartDrawer;
